module.exports = __webpack_public_path__ + "img/processing-02.689ed7ca.svg";